module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SH-a8808fb1954c75dcc992528a15ecaaa2.png";